export const formatRows = (listaItems) =>
  listaItems.map((item) => ({
    id: item.id || "Id no disponible",
    medida_descripcion: item.medida_descripcion || "Medida no disponible",
  }));
